import { NgClass } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

import { ultraAnimations } from '../../../animations';
import { ActiveDarkenDirective } from '../../../directives/active-darken.directive';
import { ActiveDirective } from '../../../directives/active.directive';
import { FocusDirective } from '../../../directives/focus.directive';
import { UltraNavigationItem } from '../../../models/ultra-navigation-item.model';
import { UltraPrimitiveIconComponent } from '../ultra-primitive-icon/ultra-primitive-icon.component';

@Component({
	selector: 'div[ultra-menu-item-expandable]',
	templateUrl: 'ultra-menu-item-expandable.component.html',
	styleUrls: ['ultra-menu-item-expandable.component.scss'],
	imports: [
		UltraPrimitiveIconComponent,
		TranslocoModule,
		NgClass,
		FocusDirective,
		ActiveDarkenDirective,
	],
	animations: ultraAnimations,
})
export class UltraMenuItemExpandableComponent {
	activeRoute = input<string>();
	item = input<UltraNavigationItem>();
	expanded = model(false);
	expandedMenuId = output<string>();

	// ngAfterViewInit() {
	// 	if (
	// 		this.item()
	// 			.children?.map((item) => item.link)
	// 			.includes(this.activeRoute())
	// 	) {
	// 		this.expanded.set(true);
	// 	}
	// }

	onExpand() {
		this.expanded.set(!this.expanded());
		if (this.expanded()) {
			this.expandedMenuId.emit(this.item().id);
		}
	}
}
